import { render, staticRenderFns } from "./Velocity.vue?vue&type=template&id=60b9cdb6&scoped=true&"
import script from "./Velocity.vue?vue&type=script&lang=js&"
export * from "./Velocity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b9cdb6",
  null
  
)

export default component.exports